import { render, staticRenderFns } from "./BSContractError0002.vue?vue&type=template&id=1367c370&"
import script from "./BSContractError0002.vue?vue&type=script&lang=js&"
export * from "./BSContractError0002.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports